import { Box, BoxProps } from '@chakra-ui/react/box';

import BuildListSkeletonContent from './BuildListSkeletonContent';

type BuildListSkeletonOverlayContentProps = { showAppInfo?: boolean } & BoxProps;
const BuildListSkeletonOverlayContent = ({ showAppInfo, children, ...rest }: BuildListSkeletonOverlayContentProps) => (
  <Box position="relative">
    <BuildListSkeletonContent count={3} showAppInfo={showAppInfo} />
    <Box
      width="100%"
      height="100%"
      position="absolute"
      top="0"
      left="0"
      backgroundImage="linear-gradient(180deg, color-mix(in srgb, var(--colors-background\/primary) 25%, transparent) 0%, var(--colors-background\/primary) 85%, var(--colors-background\/primary) 100%)"
    />
    <Box
      width="100%"
      height="100%"
      display="flex"
      flexDirection="column"
      gap="16"
      alignItems="center"
      justifyContent="center"
      position="absolute"
      top="0"
      left="0"
      {...rest}
    >
      {children}
    </Box>
  </Box>
);

export default BuildListSkeletonOverlayContent;
